import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AIChatCard from '../components/aiChat/AiChatCard';
import './CourseChatPage.css';

export default function CourseChatPage(){
  const { courseId } = useParams();
  const navigate = useNavigate();
  const courseIdNum = Number(courseId);
  return (
    <div className="course-chat-page-container">
      <header className="course-chat-page-header">
  <button className="zoom-back-btn btn btn-outline btn-sm" onClick={()=>navigate(-1)}><span className="icon" aria-hidden="true">⤢</span> Back</button>
        <h1 className="course-chat-page-title">Course Chat</h1>
      </header>
      <div className="course-chat-page-body">
        <AIChatCard mode="endeavor" endeavorId={courseIdNum} endeavorName={`Course ${courseIdNum}`} />
      </div>
    </div>
  );
}
